import 'extensions/multi-system/components/x-multi-basket-summary-container';
import {ParameterValidator} from '@mvps-genesis/utilities';

export default class Checkout {

	constructor () {

		// Create validator
		this.validator = new ParameterValidator(this);

		this.elements = {
			mainOrderSummaryToggle: this.validator.isElement('mainOrderSummaryToggle', '#js-summary-toggle'),
			orderSummaryElem: this.validator.isElement('orderSummaryElem', '#js-checkout-summary'),
			orderSummaryToggles: this.validator.isElementList('orderSummaryToggles', '.js-toggle-summary')
		};

		this.toggleClass = 't-checkout-summary-toggle__open';

		this.bindEvents();
	}

	bindEvents () {
		for (const toggle of this.elements.orderSummaryToggles) {
			toggle.addEventListener('click', (e) => this.toggleOrderSummary(e), false);
		}

		window.addEventListener('resize', () => this.resizedOrderSummary(), false);
	}

	toggleOrderSummary (e) {
		if (e) {
			e.preventDefault();
		}

		if (this.elements.mainOrderSummaryToggle.classList.contains(this.toggleClass)) {
			this.elements.mainOrderSummaryToggle.classList.remove(this.toggleClass);

			if (this.constructor.isVisible(this.elements.orderSummaryElem)) {
				this.constructor.slideUp(this.elements.orderSummaryElem);
			}
		} else {
			this.elements.mainOrderSummaryToggle.classList.add(this.toggleClass);

			if (!this.constructor.isVisible(this.elements.orderSummaryElem)) {
				this.constructor.slideDown(this.elements.orderSummaryElem);
			}
		}
	}

	resizedOrderSummary () {
		if (this.constructor.isVisible(this.elements.mainOrderSummaryToggle)) {
			if (this.elements.mainOrderSummaryToggle.classList.contains(this.toggleClass)) {
				if (!this.constructor.isVisible(this.elements.orderSummaryElem)) {
					this.constructor.slideDown(this.elements.orderSummaryElem);
				}
			} else if (this.constructor.isVisible(this.elements.orderSummaryElem)) {
				this.constructor.slideUp(this.elements.orderSummaryElem);
			}
		} else if (!this.constructor.isVisible(this.elements.orderSummaryElem)) {
			this.constructor.slideDown(this.elements.orderSummaryElem);
		}
	}

	static isVisible (ele) {
		return ele.clientWidth !== 0 &&
			ele.clientHeight !== 0 &&
			ele.style.opacity !== 0 &&
			ele.style.visibility !== 'hidden';
	}

	static slideDown (target, duration = 500) {
		target.style.removeProperty('display');
		let display = window.getComputedStyle(target).display;

		if (display === 'none') {
			display = 'block';
		}

		target.style.display = display;
		let height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		setTimeout(() => {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}

	static slideUp (target, duration = 500) {
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = duration + 'ms';
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		window.setTimeout(() => {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
		}, duration);
	}
}
